import $ from 'jquery';

$(function () {
    var el = $('[data-contact-button]');

    if (!el.length) return;



    var trigger = el.find('[data-contact-button-trigger]');
    var content = el.find('[data-contact-button-content]');

    trigger.on('click', function () {
        el.toggleClass('active');
        if (el.hasClass('active')) {
            var h = content.get(0).scrollHeight;
            content.css({ height: h + 'px' });
        } else {
            content.css({ height: '0px' });
        }
    });

    $(window.document).on('click', function (e) {
        var cb = $(e.target).closest('[data-contact-button]');
        if (!cb.length && el.hasClass('active')) {
            trigger.click();
        }
    });
});